import { render } from "./TimeoutDialog.vue?vue&type=template&id=389b3c54"
import script from "./TimeoutDialog.vue?vue&type=script&lang=js"
export * from "./TimeoutDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__